// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_pK6","cls2":"SingularMentionCitationModal-cls2_i2J SingularMentionCitationModal-cls1_pK6"};